import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { PaymentRouter } from "./PaymentRouter";
import { usePaymentCore } from "@/features/payment";
import { useTranslation } from "react-i18next";

export interface PaymentModalProps {
  children?: React.ReactNode;
}

export const PaymentModal: React.FC<PaymentModalProps> = ({ children }) => {
  const { isPaymentModalOpen, closePaymentModal } = usePaymentCore();
  const { t } = useTranslation();

  // Focus management için ref
  const dialogRef = React.useRef<HTMLDivElement>(null);

  return (
    <Dialog open={isPaymentModalOpen} onOpenChange={closePaymentModal}>
      <DialogContent
        open={isPaymentModalOpen}
        className="max-w-4xl max-h-[90vh] overflow-y-auto"
      >
        <DialogTitle className="sr-only">{t("payment.title")}</DialogTitle>
        <DialogDescription className="sr-only">
          {t("payment.description")}
        </DialogDescription>
        <div
          ref={dialogRef}
          className="relative z-[100] focus:outline-none w-full"
        >
          <PaymentRouter />
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};
